<template>
    <van-tabbar v-model="active" class="tabbar" route>
        <!-- <van-tabbar-item name="home" replace to="/">
            <van-icon
                class="icon"
                class-prefix="f-icon"
                :name="active=='home'?'home-selected':'home1'"
            />
            <div class="txt">首页</div>
        </van-tabbar-item>-->
        <van-tabbar-item
            replace
            to="/cart"
            name="cart"
            :info="cart_goods_num&&active!='cart'?cart_goods_num:''"
        >
            <van-icon
                class="icon"
                class-prefix="f-icon"
                :name="active=='cart'?'cart-selected':'cart'"
            />
            <div class="txt">购物车</div>
        </van-tabbar-item>
        <van-tabbar-item replace to="/my" name="user">
            <van-icon
                class="icon"
                class-prefix="f-icon"
                :name="active=='user'?'user-selected':'user'"
            />
            <div class="txt">我的</div>
        </van-tabbar-item>
    </van-tabbar>
</template>

<script>
import { Cart } from '@/models/cart'
const cart = new Cart()
export default {
    name: 'MyTabbar',
    components: {},
    props: {
        current: {
            type: String,
            default: 'home'
        }
    },
    data() {
        return {
            active: '',
            cart_goods_num: 0
        }
    },
    mounted() {
        this.active = this.$props.current
        this.cart_goods_num = cart.getCartItemCount()
    }
}
</script>
<style lang='stylus'>
.tabbar
    height: 55px
    .van-tabbar-item, .van-tabbar-item .icon
        color: #515151
    .van-tabbar-item--active, .van-tabbar-item--active .icon
        color: #ff8c00
    .van-tabbar-item
        justify-content: center
        text-align: center
        .icon
            font-size: 30px
        .txt
            font-size: 12px
            margin-top: 2px
        .van-info
            // font-size: 10px
            margin-top: 0
            right: -8px
            top: 2px
            border-radius: 50%
            height: 20px
            width: 20px
            line-height: 20px
            text-align: center
            padding: 0px
</style>
